import {
  AsyncTaskAPIStatusCodes,
  IAsyncTaskResponse,
  IUseAsyncTask,
} from 'src/utilities/useAsyncTask';

export interface UseAsyncDownloadTask extends IUseAsyncTask {
  startAsyncTask: (
    asyncTaskFunction: () => Promise<IAsyncTaskResponse>
  ) => Promise<void>;
}

export enum AsyncDownloadTaskAPIStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
}

export interface InitiateAsyncTaskResponse {
  id: string;
  uri: string;
  __status__: number;
}

export interface AsyncDownloadTaskResponse {
  status: AsyncDownloadTaskAPIStatus;
  download_url: string;
}

export const asyncDownloadTaskToAsyncTaskMap = new Map<
  AsyncDownloadTaskAPIStatus,
  AsyncTaskAPIStatusCodes
>([
  [AsyncDownloadTaskAPIStatus.IN_PROGRESS, AsyncTaskAPIStatusCodes.IN_PROGRESS],
  [
    AsyncDownloadTaskAPIStatus.COMPLETE,
    AsyncTaskAPIStatusCodes.COMPLETED_SUCCESSFULLY,
  ],
  [
    AsyncDownloadTaskAPIStatus.ERROR,
    AsyncTaskAPIStatusCodes.COMPLETED_UNSUCCESSFULLY,
  ],
]);

export function initiateAsyncTaskResponseTransformer({
  id,
  uri,
  __status__,
}: InitiateAsyncTaskResponse): IAsyncTaskResponse {
  return { uri, task_id: id, __status__ };
}

export const pollingResponseTransformer = ({
  status,
  download_url,
}: AsyncDownloadTaskResponse): IAsyncTaskResponse => ({
  __status__: asyncDownloadTaskToAsyncTaskMap.get(status),
  download_url,
});
